import moment, { Moment } from 'moment'

import { createSelector } from 'reselect'

import { RootState } from 'core/reducers'
import { CriterionV2 } from 'constants/service'
import { DEFAULT_DATE_FORMAT } from 'constants/date'
import { MedicationFormStatusOptionProps, STORED_ON_SITE } from 'services/medicationForms/constants'

import { createTypeFromEnumValues } from 'utils/typescript'

export const getMedicationFormsSelector = (state: RootState) => state.medicationForms

export const getMedicationFormsListSelector = createSelector(
  [getMedicationFormsSelector],
  (state) => state.list.data,
)

interface GetCriteriaProps {
  childId?: number
  dateRange?: Moment[]
  medicationFormStatus?: MedicationFormStatusOptionProps
  room?: number
  search?: string
  storedOnSite?: createTypeFromEnumValues<STORED_ON_SITE>
}

export const getCriteria = ({
  childId,
  dateRange,
  medicationFormStatus,
  room,
  search,
  storedOnSite,
}: GetCriteriaProps): CriterionV2[] => {
  const criteria = [{
    field: 'archived',
    value: false,
  }] as any

  if (childId) {
    criteria.push({
      field: 'child',
      value: childId,
    })
  }

  if (medicationFormStatus) {
    criteria.push({
      field: 'status',
      value: medicationFormStatus,
    })
  }

  if (storedOnSite) {
    criteria.push({
      field: 'medicationDetails.storeOnSite',
      value: storedOnSite === STORED_ON_SITE.ON_SITE ? 1 : 0,
    })
  }

  if (dateRange && dateRange[0] && dateRange[1]) {
    criteria.push({
      comparator: 'after',
      field: 'endDate',
      value: moment(dateRange[0]).format(DEFAULT_DATE_FORMAT),
    })

    criteria.push({
      comparator: 'before',
      field: 'startDate',
      value: moment(dateRange[1]).format(DEFAULT_DATE_FORMAT),
    })
  }

  if (search) {
    criteria.push({
      field: 'concatenable',
      value: search,
    })
  }

  if (room) {
    criteria.push({
      field: 'child.nurseryClass',
      value: room,
    })
  }

  return criteria
}
